import { CoverpathUtils } from '../../../../../../coverpath-common/js/static/CoverpathUtils';
import { Utils } from '../../../../../../common/js/Utils';
import { Controller } from '../../../Controller';
import { BasicIllustrationService } from '../../../../../../coverpath-common/angular/services/basicillustration/BasicIllustrationService';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { QuickQuoteService } from '../../../services/quote/quick-quote.service';
import { Router } from '@angular/router';
import { CoverpathCustomer } from '../../../../../../coverpath-common/classes/coverpath_subclasses/CoverpathCustomer';

export class BaseQuoteCard {
  protected controller: Controller;
  protected fetchingIllustration: boolean;

  // Client properties
  clientName: string;
  protected insuredName: string;
  protected age: string;
  protected gender: string;
  protected isSmoker: boolean;
  protected dob: string;
  protected pronoun: string;
  // Advisor properties
  protected advisorName: string;

  // Quote properties
  protected faceAmount: string;
  protected term: string;
  protected hasWaiverOfPremium: boolean;
  protected waiverOfPremium: string;
  protected estimatedPremium: string;
  protected healthClassDesc: string;
  protected healthClassNumber: number;
  isAgentAssisted: boolean;
  protected frequencyUnit: string;
  protected hasEcp: boolean;
  protected isART: boolean;

  constructor(
    protected amorphicService: AmorphicService,
    protected router: Router,
    protected quickQuoteService: QuickQuoteService,
    protected basicIllustrationService: BasicIllustrationService
  ) {
    this.controller = amorphicService.controller as Controller;
  }

  /**
   * Generates a basic illustration, and opens it in a new tab
   *
   * @param controller the application controller
   * @param basicIllustrationService the basic illustration service
   *
   * @remarks keeps `this.fetchingIllustration` updated with status of this call
   */
  protected getBasicIllustrationPdf(isSupplemental: boolean = false): void {
    this.fetchingIllustration = true;
    CoverpathUtils.dataLayerPush({
      event: 'vst-get-basicillustration',
    });
    const customer: CoverpathCustomer = this.controller.customer;
    const agent = customer.application.primaryPolicy.primaryPolicyAgent.primaryAgent;
    const illustrationRequest = this.basicIllustrationService.createDefaultIllustrationRequest(
      customer,
      agent,
      isSupplemental
    );

    this.basicIllustrationService
      .generateBasicIllustrationPDF(illustrationRequest, false)
      .then((response) => {
        if (response) {
          Utils.openFileInNewWindow(response, 'application/pdf');
        }
        this.fetchingIllustration = false;
      })
      .catch((e) => {
        this.fetchingIllustration = false;
      });
  }

  /**
   * Route to a new page
   * @param route the desired route
   */
  protected routeTo(route: string): void {
    this.router.navigate([route]);
  }

  /**
   * Begins application using Quick Quote Service
   */
  applyWithQuote(): void {
    this.quickQuoteService.setCustomerQuote();
    this.quickQuoteService.routeCustomer();
  }
}
